import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To run our business we need to beam your stuff around the internet.
You're cool with that and happy to answer for the stuff you put on HostJane.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      